import { get } from 'utils/lodash'
import { ReactComponent as InvoiceIcon } from 'assets/invoice/Invoice.svg'
import { ReactComponent as InvoiceSuccessIcon } from 'assets/invoice/InvoiceSuccess.svg'
import { ReactComponent as ArrowSpinIcon } from 'assets/invoice/ArrowSpin.svg'
import { X as CloseIcon } from '@styled-icons/heroicons-solid/X'

import { green, red, orange, grey, blue, amber } from '@mui/material/colors'
import { INVOICE_STATUS, INVOICE_GENERATION_STATUS, INVOICE_GENERATION_STATUS_LABELS } from 'settings/constants/billing'
import { AGING_BUCKET_COLORS } from '../aging-bucket/settings'

const { PARTIAL, UNPAID, PAID } = INVOICE_STATUS

const INVOICE_GENERATION_ICONS = {
  Started: ArrowSpinIcon,
  Completed: InvoiceSuccessIcon,
  Failed: CloseIcon,
  Regeneration_Started: ArrowSpinIcon,
  Regeneration_Completed: InvoiceSuccessIcon,
  Regeneration_Failed: CloseIcon,
  N_A: InvoiceIcon,
}

export const getInvoiceChipParams = (status, isPartial, agingBucketType) => {
  if (status === UNPAID && agingBucketType) {
    return { color: AGING_BUCKET_COLORS[agingBucketType], label: isPartial ? PARTIAL : UNPAID }
  }

  if (status === PAID) {
    return { color: green, label: PAID }
  }

  if (status === PARTIAL) {
    return { color: grey, label: 'Draft' }
  }

  if (status === UNPAID) {
    return isPartial ? { color: orange, label: PARTIAL } : { color: blue, label: UNPAID }
  }

  return { color: red, label: status }
}

export const getInvoiceGenerationStatusParams = (generationStatus, generationFailure) => {
  if (!generationStatus) {
    return { Icon: InvoiceIcon, type: '', text: '', bgcolor: grey[100] }
  }

  const isGenerating = [INVOICE_GENERATION_STATUS.Started, INVOICE_GENERATION_STATUS.Regeneration_Started].includes(generationStatus)
  const isFailed = [INVOICE_GENERATION_STATUS.Failed, INVOICE_GENERATION_STATUS.Regeneration_Failed].includes(generationStatus)
  const failureReason = isFailed ? get(generationFailure, 'error', '') : ''

  return {
    Icon: get(INVOICE_GENERATION_ICONS, generationStatus, InvoiceIcon),
    label: get(INVOICE_GENERATION_STATUS_LABELS, generationStatus, ''),
    fullLabel: `${get(INVOICE_GENERATION_STATUS_LABELS, generationStatus, '')}${failureReason ? `: ${failureReason}` : ''}`,
    bgcolor: (() => {
      if (isFailed) return red[500]
      if (isGenerating) return amber[700]
      return grey[100]
    })(),
  }
}
